import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import ArgonInput from "components/ArgonInput";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
// baseUrl
import { baseURL } from "utils/api";
import axios from "utils/api";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

function Index() {
  const [className, setClassName] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();
  console.log("Class ID from URL:", id);

  //get api se class ka data lana hai id ke sath input field mai show karne ke liye
  //aur fir update karne ke liye put api call karni hai

  useEffect(() => {
    axios
      .get(`${baseURL}/classes/${id}`)
      .then((res) => {
        console.log("Class details:", res.data);
        if (res.data.success) {
          setClassName(res.data.data.name);
        }
      })
      .catch((err) => {
        console.error("Error fetching class details:", err);
      });
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!className.trim()) {
      toast.error("Class name cannot be empty");
      //   alert("Please enter class name");
      return;
    }
    console.log("New Class Added:", className);
    // setClassName(""); // reset input

    axios
      .put(`${baseURL}/classes/${id}`, { name: className })
      .then((response) => {
        console.log(response.data);
        toast.success(response.data?.message || "Class updated successfully");
        navigate("/curriculum");
      })
      .catch((error) => {
        console.error("Error updating class:", error);
        // toast.error(error.response?.data?.message || "Failed to update class");
        toast.error(error.response?.data?.error);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card sx={{ p: 3, borderRadius: "16px", boxShadow: 3 }}>
            <ArgonTypography mb={1} variant="h5" fontWeight="bold">
              Edit Class
            </ArgonTypography>
            <Divider sx={{ mb: 3 }} />

            <form onSubmit={handleSubmit}>
              <ArgonBox display="flex" alignItems="center" gap={2}>
                {/* Input Field */}
                <ArgonBox>
                  <ArgonInput
                    type="text"
                    placeholder="Enter Class Name"
                    value={className}
                    onChange={(e) => setClassName(e.target.value)}
                    sx={{ width: "50%" }}
                  />
                </ArgonBox>
                {/* Button */}
                <ArgonButton
                  color="primary"
                  type="submit"
                  variant="contained"
                  // sx={{ minWidth: "150px", height: "100%" }}
                >
                  Update Class
                </ArgonButton>
              </ArgonBox>
            </form>
          </Card>
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Index;
